import React from 'react';
export function Footer() {
  return <footer className="bg-[#1E2330] py-16 px-5 sm:px-6 border-t border-[#2A3040] text-center" data-id="element-151">
      <div className="container mx-auto max-w-3xl" data-id="element-152">
        <h3 className="text-[#D4AF37] font-serif font-bold text-xl md:text-2xl mb-3 tracking-widest" data-id="element-153">
          🪷 ACADEMIA HOLÍSTICA ARGENTINA™
        </h3>
        <p className="text-white/70 text-sm md:text-base mb-10" data-id="element-154">
          El sistema de formación en Reiki N°1 para Argentina. Porque tu camino
          espiritual no debería postergarse por falta de una formación a la
          altura.
        </p>

        <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8 text-white/50 text-sm mb-12" data-id="element-155">
          <span className="flex items-center gap-2" data-id="element-156">
            📧 academiaholisticaargentina@gmail.com
          </span>
          <span className="flex items-center gap-2" data-id="element-157">
            📲 Instagram: @academiaholisticaargentina
          </span>
          <span className="flex items-center gap-2" data-id="element-158">
            📘 Facebook: Academia Holística Argentina
          </span>
        </div>

        <div className="text-white/30 text-xs space-y-4" data-id="element-159">
          <p data-id="element-160">
            © Academia Holística Argentina™ 2026 — Todos los derechos
            reservados.
          </p>
          <p data-id="element-161">
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
          <p className="text-[#D4AF37] font-serif italic text-lg mt-8" data-id="element-162">
            🪷 "El momento que siempre esperaste ya llegó."
          </p>
        </div>
      </div>
    </footer>;
}